import { BREAKPOINTS, LOCALES, NodeProps, Props } from '../metadata';

import { getBreakpointProps, getLocaleProps } from '.';

function resolveProps(props: NodeProps, breakpoint: string = '', locale: string = ''): Props {
  const breakpointProps = getBreakpointProps(props, breakpoint);
  const localeProps = getLocaleProps(props, locale) as NodeProps;
  const localeBreakpointProps = getBreakpointProps(localeProps, breakpoint);

  const defaultProps = { ...props };

  deleteScopedProperties(defaultProps, [BREAKPOINTS, LOCALES]);
  deleteScopedProperties(localeProps, [BREAKPOINTS]);

  return {
    ...defaultProps,
    ...breakpointProps,
    ...localeProps,
    ...localeBreakpointProps,
  };
}

function deleteScopedProperties(props: NodeProps, scopes: string[]): void {
  scopes.forEach((scope) => {
    delete props[scope];
  });
}

export default resolveProps;
